import axios from 'axios';

const configsApiBaseUrl = process.env.REACT_APP_CONFIGS_API || process.env.REACT_APP_API_URL;

const config = axios.create({
  baseURL: `${configsApiBaseUrl}/api`,
});

config.interceptors.request.use(async (config) => {
  try {
    config.headers.Authorization = `Bearer ${process.env.REACT_APP_CONFIGS_API_TOKEN}`;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});


export default config
